export const callBrandingPathResources = {
    phoneNumbers: "phone-numbers",
    businessProfiles: "business-profiles",
} as const;
